import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Application } from "./applications-interface";
import { UserService } from "../../../services/UserService";

export const fetchApplications = createAsyncThunk(
  "applications/fetchApplications",
  async () => {
    const client = getAxiosClient();

    // ✅ Use getParsedToken to safely extract roles
    const token = UserService.getParsedToken();
    const roles: string[] =
      token?.resource_access?.["analytics-service"]?.roles ?? [];

    // ✅ Use helper to get email
    const email = UserService.getUserEmail() ?? "";

    let response;
    if (roles.includes("Eizen") || roles.includes("Administrator")) {
      // fetch all applications
      response = await client.get("api/eza_app_application");
    } else {
      response = await client.get(
        // fetch only user-created applications
        `api/eza_app_application/createdBy/${encodeURIComponent(email)}`
      );
    }

    return response.data as Application[];
  }
);

export const fetchApplicationsByUuid = createAsyncThunk(
  "applications/fetchApplicationsByUuid",
  async (uuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_application/uuid/${uuid}`);
    return response.data as Application;
  }
);
